export { EloDeleteCircleIcon } from './delete-circle-icon'
